import { get, kebabCase } from 'lodash';
import syncFormData from 'APP_ROOT/actions/sync-form-data';
import syncFormValueChanged from 'APP_ROOT/actions/sync-form-value-changed-boolean';
import { mapFormChanges } from 'APP_ROOT/utils/form';
import mapPropsToFields, {
  getFormAttachments,
  initializeFormFields,
} from 'APP_ROOT/utils/map-props-to-fields';

export const reportFormName = 'form';
export const DEFAULT_HEIGHT = 215;

export const reportFormOptions = {
  onValuesChange: props => {
    const { dispatch } = props;
    dispatch(syncFormValueChanged(true));
  },
  onFieldsChange: (props, form) => {
    const {
      dispatch,
      selectedForm: {
        data = {},
        presentation = {},
        state: formState = {},
      } = {},
    } = props;

    const { changes, state } = mapFormChanges(
      data,
      form,
      presentation,
      formState
    );

    dispatch(syncFormData(changes, state));
  },
  mapPropsToFields: props => {
    const { selectedForm = {}, attachments = {} } = props;
    const { data = {}, state = {}, presentation = {} } = selectedForm;
    const template = kebabCase(get(selectedForm, ['template', 'type'], ''));
    const extraFields = getFormAttachments(
      attachments,
      template,
      selectedForm.id
    );

    return initializeFormFields(
      mapPropsToFields(data, state, presentation, extraFields)
    );
  },
};
